import nbrApi from '../../../services/nbrApi'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux';
import { saveTokenInLocalStorage } from '../../../services/AuthService';
import { loginConfirmedAction, Logout, updateSelectedLoginData, updateUserData } from '../../../store/actions/AuthActions';
import { crypt, getPropertiesData, getRolesArray, getUserDetailsAll, hasDifferentRoleOrProperty, storeUniqueProperties } from '../../../services/common.utils';
import { useNavigate } from 'react-router-dom';


function ReLogin() {
    let selectedLoginData = JSON.parse(localStorage.getItem('selectedLoginData')) || null
    const userData = JSON.parse(localStorage.getItem('userDetails'))
    const userDataAll = JSON.parse(localStorage.getItem('userDetailsAll'))
    let propertyDetails = userDataAll?.user_info?.properties_roles_array?.find(e => e?.properties_id === parseInt(selectedLoginData?.properties_id))
    // console.log(propertyDetails, 'pp details')
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoginSuccess, setLoginSuccess] = useState(false)
    const [loginData, setLoginData] = useState({})
    const [properties, setProperties] = useState([])
    const [roles, setRoles] = useState([])
    const [step, setStep] = useState(1);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [diffRoleProperty, setIsDiffRoleProperty] = useState(null)
    const [mrrID, setMrrID] = useState('')
    const [resourceID, setResourcesID] = useState('')
    const [selectedLogo, setSelectedLogo] = useState('')

    const handleLoginSuccess = (data) => {
        setLoginData(data);
        dispatch(updateUserData(data));
        saveTokenInLocalStorage(data);
        const propertiesData = data.map(e => ({
            ...e,
            value: e.properties_id,
            label: e.property_name
        }));
        const uniqueProperties = storeUniqueProperties(propertiesData);
        setProperties(uniqueProperties);

        const rolesData = data.map(e => ({
            ...e,
            value: e.roles_id,
            label: e.role_name
        }));
        setRoles(rolesData);

        setLoginSuccess(true);
    };

    // handle property select dropdown
    const handlePropertySelect = (property) => {
        setSelectedProperty(property);
        const propId = parseInt(property, 10);
        const defaultRoleId = selectedLoginData?.role_id;
        const defaultFitsProperty =
            property !== '' &&
            defaultRoleId != null &&
            roles?.some(
                e => e?.properties_id === propId && String(e?.value) === String(defaultRoleId)
            );
        setSelectedRole(defaultFitsProperty ? String(defaultRoleId) : '');
        // setSelectedLogo(property?.logo_url)
        setMrrID(property?.mrr_id)
        if (property !== '') {
            setStep(2);
        }
    };

    // handle role select dropdown
    const handleRoleSelect = (role) => {
        setSelectedRole(role);
        setSelectedLogo(role?.logo_url)
        setResourcesID(role?.resources_id);
        setMrrID(role?.mrr_id)
    };

    useEffect(() => {
        if (selectedProperty && selectedRole) {
            let filterData = userDataAll?.user_info?.properties_roles_array?.find(e => e?.properties_id && parseInt(selectedProperty) && e?.roles_id === parseInt(selectedRole))
            setMrrID(filterData?.mrr_id)
            setSelectedLogo(filterData?.logo_url)
        }
    }, [selectedProperty, selectedRole])
    // init
    useEffect(() => {
        if (selectedLoginData?.email) {
            // getData(selectedLoginData?.email)
            if (userDataAll?.user_info?.properties_roles_array?.length > 0) {
                setLoginSuccess(true);
                let isResp = hasDifferentRoleOrProperty(userDataAll?.user_info?.properties_roles_array);
                setIsDiffRoleProperty(isResp)
                if (isResp === 'false') {
                    setRoles(getRolesArray(userDataAll?.user_info?.properties_roles_array))
                } else {
                    handleLoginSuccess(userDataAll?.user_info?.properties_roles_array);
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                });
                setLoginSuccess(false);
            }
        }
    }, [selectedLoginData?.email])

    // Pre-populate property and current session role as default (stay on Step 1 for multi-property flow).
    useEffect(() => {
        if (!isLoginSuccess || !selectedLoginData?.properties_id) return;
        const currentPropId = selectedLoginData.properties_id ? String(selectedLoginData.properties_id) : '';
        const currentRoleId = selectedLoginData.role_id != null ? String(selectedLoginData.role_id) : '';
        setSelectedProperty(currentPropId);
        setSelectedRole(currentRoleId);
        setStep(1); // Show Step 1 (Property select) first; user can click Next to see Role
    }, [isLoginSuccess, selectedLoginData?.properties_id, selectedLoginData?.role_id])


    // handle Save
    const handleLogin = async () => {
        if (isLoginSuccess && selectedProperty && selectedRole && selectedLoginData?.email) {
            let selectedData = {
                properties_id: selectedProperty,
                role_id: selectedRole,
                email: selectedLoginData?.email
            }
            let filterData = userDataAll?.user_info?.properties_roles_array?.find(e => e?.properties_id === parseInt(selectedProperty) && e?.roles_id === parseInt(selectedRole))
            let payload = {
                properties_id: selectedProperty ? Number(selectedProperty) : '',
                resources_id: filterData?.resources_id ? Number(filterData?.resources_id) : '',
                mrr_id: filterData?.mrr_id ? Number(filterData?.mrr_id) : '',
                sessionlog_id: userDataAll?.session_info?.last_sessionlog_id,
                login_function: "relogin"
            }
            localStorage.setItem('selectedLoginData', JSON.stringify(selectedData))
            dispatch(updateSelectedLoginData(selectedData))
            // map data
            let properties_id = selectedProperty ? selectedProperty : selectedLoginData?.properties_id
            let role_id = selectedRole ? selectedRole : selectedLoginData?.role_id

            let myData = loginData?.filter(e => parseInt(e?.properties_id) === parseInt(properties_id) && parseInt(e?.roles_id) === parseInt(role_id))?.[0] || {}
            let staticData = {
                "localId": crypt(myData?.resources_id),
                "displayName": myData?.resource_first + ' ' + myData?.resource_last,
                "idToken": crypt(myData?.resources_id),
                "registered": true,
                "refreshToken": crypt(myData?.resources_id),
            }
            // console.log(staticData)
            dispatch(loginConfirmedAction(staticData));

            // call session API
            const response = await nbrApi.post('/login', payload)

            let userData = response?.data
            // console.log(userData)
            let userDetailsAllData = getUserDetailsAll(userData)
            if (response?.data?.user_info?.properties_roles_array?.length > 0) {
                localStorage.setItem('userDetailsAll', JSON.stringify(userDetailsAllData));
            }
            setStep(1)
            Swal.fire({
                icon: "success",
                title: "Success",
                text: diffRoleProperty === 'true' ? "Property/Role updated successfully" : "Role updated successfully",
                timer: 2000,
                showConfirmButton: false,
                willClose: () => {
                    // console.log(selectedLogo)
                    let modify_data = {
                        ...userDetailsAllData,
                        session_info: {
                            ...response?.data?.session_info,
                            logo_url: selectedLogo
                        },
                        // user_info: {
                        //     ...response?.data?.user_info,
                        //     properties_id: response?.session_info?.properties_id
                        // }
                    }

                    let loginData = {
                        ...selectedLoginData,
                        properties_id: response?.data?.session_info?.properties_id,
                        role_id: response?.data?.session_info?.roles_id
                    }
                    if (modify_data?.user_info?.properties_roles_array?.length === 0) {
                        Swal.fire({
                            icon: 'error',
                            title: 'User session loading failed',
                            text: 'Please relogin to continue.',
                            showCancelButton: true,
                            confirmButtonText: 'Logout',
                            cancelButtonText: 'Cancel',
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                dispatch(Logout(navigate));
                            }
                        }); 
                    } else {
                        if (response?.data && modify_data?.user_info?.properties_roles_array?.length > 0) {
                            localStorage.setItem('userDetailsAll', JSON.stringify(modify_data))
                            localStorage.setItem('selectedLoginData', JSON.stringify(loginData))
                        }
                        // Follow same redirect rules as Login: roomops → monitor, else → /dashboard
                        const roleName = filterData?.role_name || myData?.role_name || '';
                        const isRoomopsRole = roleName && (
                            roleName.toLowerCase().includes('roomops') ||
                            roleName.toLowerCase() === 'roomops monitor' ||
                            roleName.toLowerCase() === 'roomops admin' ||
                            roleName.toLowerCase() === 'roomops manager'
                        );
                        window.location.href = isRoomopsRole ? '/multi-property-monitor' : '/dashboard';
                    }
                }
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
            });
        }
    }

    useEffect(() => {
        if (diffRoleProperty === 'false') {
            setStep(2)
            setSelectedProperty(propertyDetails?.properties_id)
            const defaultRoleId = selectedLoginData?.role_id != null ? String(selectedLoginData.role_id) : '';
            setSelectedRole(defaultRoleId)
            setResourcesID(propertyDetails?.resources_id);
            setMrrID(propertyDetails?.mrr_id);
        }
    }, [diffRoleProperty, selectedLoginData?.properties_id, selectedLoginData?.role_id])

    const rolesForProperty = roles?.filter(e => e?.properties_id === parseInt(selectedProperty, 10)) ?? [];
    const hasValidRoleSelection =
        selectedRole !== '' &&
        rolesForProperty.some(e => String(e?.value) === String(selectedRole));

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    {diffRoleProperty && <div className="card-header">
                        <h4 className="heading me-2">{diffRoleProperty === 'true' ? 'Change Property/Role' : 'Change Role'}</h4>
                        <button type='button' className='btn btn-sm btn-primary' onClick={() => navigate(-1)}>Go Back</button>
                    </div>}
                    <form className="dz-form pb-3 col-lg-6 mx-auto mt-5">
                        {step === 1 && diffRoleProperty === 'true' && (
                            <>
                                <div className="form-group mb-3">
                                    <label className='fw-bold text-black'>Property</label>
                                    <select className="form-control" value={selectedProperty} onChange={(e) => handlePropertySelect(e.target.value)} required>
                                        <option value="">Select Property</option>
                                        {/* Populate options from your data */}
                                        {properties?.map((e, index) => (
                                            <option value={e?.value} key={index}>{e?.label}</option>
                                        ))}
                                    </select>
                                    {!selectedProperty && <div className="text-danger fs-12 m-2">{'Please select Property'}</div>}
                                </div>
                                <div className="form-group text-left mb-5 text-center">
                                    <button type="button" disabled={!selectedProperty} className="btn btn-sm btn-primary dz-xs-flex m-r5" onClick={() => setStep(2)}>Next</button>
                                </div>
                            </>
                        )}
                        {step === 2 && (
                            <>
                                <div className="form-group mb-3">
                                    <label className='fw-bold text-black'>Role</label>
                                    <select className="form-control text-capitalize" value={selectedRole} onChange={(e) => handleRoleSelect(e.target.value)} required>
                                        <option value="">Select Role</option>
                                        {/* Populate options from your data */}
                                        {roles?.filter(e => e?.properties_id === parseInt(selectedProperty))?.map((e, index) => (
                                            <option value={e?.value} key={index} className='text-capitalize'>{e?.label}</option>
                                        ))}
                                    </select>
                                    {!selectedRole && <div className="text-danger fs-12 m-2">{'Please select Role'}</div>}
                                </div>
                                <div className="form-group d-flex text-left mb-5 justify-content-center">
                                    {diffRoleProperty === 'true' && <button type="button" className="btn btn-sm btn-primary dz-xs-flex m-r5 mx-2" onClick={() => setStep(1)}>Prev</button>}
                                    <button type="button" disabled={!selectedProperty || !hasValidRoleSelection} onClick={handleLogin} className="btn btn-sm btn-primary dz-xs-flex m-r5">Login</button>
                                </div>
                            </>
                        )}
                    </form>
                </div>

            </div>
        </div>

    )
}

export default ReLogin